import React from 'react';
import type { Experience, Taxonomy } from '@axiom/validation';

import { Accordions } from '../../layout/Accordions/Accordions';
import { AccordionsItem } from '../../layout/Accordions/AccordionsItem';
import { AccordionsItemHeader } from '../../layout/Accordions/AccordionsItemHeader';
import { AccordionsItemSection } from '../../layout/Accordions/AccordionsItemSection';
import { Badge } from '../../element/Badge/Badge';
import { CondensedHeader } from '../../content/CondensedHeader/CondensedHeader';
import { CondensedLarge } from '../../content/CondensedLarge/CondensedLarge';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { CandidateTaxonomyUtil } from '../../../utils/candidate-taxonomy-util';
import { ExperienceTaxonomyLegalSkillsDisplay } from '../ExperienceTaxonomyLegalSkills/ExperienceTaxonomyLegalSkillsDisplay';

export type CandidateExperienceTaxonomyDetailsProps = {
  experience: Experience;
  taxonomy: Taxonomy;
};

export const CandidateExperienceTaxonomyDetails = ({
  experience,
  taxonomy,
}: CandidateExperienceTaxonomyDetailsProps) => {
  const {
    experiencesFocusAreaOrderPreferences,
    generalSkills: experienceGeneralSkills,
    experienceTaxonomy,
  } = experience;

  const skillsCount = CandidateTaxonomyUtil.getSkillsCount(
    experienceTaxonomy,
    experienceGeneralSkills
  );

  return (
    <Accordions name="CANDIDATE_EXPERIENCE_TAXONOMY_DETAILS">
      <AccordionsItem>
        <AccordionsItemHeader name="CANDIDATE_EXPERIENCE_TAXONOMY_DETAILS_HEADER">
          <div
            data-test="pendo-analytics-experience-taxonomy-display"
            data-pendo-analytics-id="experience-taxonomy-display"
            data-pendo-analytics-experience-id={experience.id}
          >
            <Layout direction="horizontal" horizontalGutter="8px">
              <LayoutItem>
                <CondensedHeader>Skills used</CondensedHeader>
              </LayoutItem>
              <LayoutItem>
                <Badge background="light orange" name="SKILLS_COUNT">
                  {skillsCount}
                </Badge>
              </LayoutItem>
            </Layout>
          </div>
        </AccordionsItemHeader>
        <AccordionsItemSection>
          <Gutter bottom="24px" />
          <ExperienceTaxonomyLegalSkillsDisplay
            name="EXPERIENCE_TAXONOMY_LEGAL_SKILLS_DISPLAY"
            experienceTaxonomy={experienceTaxonomy}
            experiencesFocusAreaOrderPreferences={
              experiencesFocusAreaOrderPreferences
            }
            taxonomy={taxonomy}
          />
          {(experienceGeneralSkills?.length ?? 0) > 0 && (
            <Gutter top="16px">
              <CondensedHeader>General Skills</CondensedHeader>
              <CondensedLarge name="GENERAL_SKILLS">
                {experienceGeneralSkills
                  ?.sort()
                  .map(gs => taxonomy.generalSkills[gs]?.displayName)
                  .join('; ')}
              </CondensedLarge>
            </Gutter>
          )}
        </AccordionsItemSection>
      </AccordionsItem>
    </Accordions>
  );
};
